import { Typography } from 'app/components';
import { i18n } from 'app/utils/i18n';

import './RemoveUser.scss';

export const RemoveUser = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="remove-user">
      <button onClick={() => onClick()} className="remove-user__button">
        <i className="fa-regular fa-trash-can" />
        <Typography variant="body-7" fontWeight="light" color="rgb(30, 37, 51)">
          {i18n('document-permissions.list.menu-item.remove-user')}
        </Typography>
      </button>
    </div>
  );
};
